import { CatalogRequestParams } from '@/src/lib/category/types';

export function hydrateArrayParams(searchParams: URLSearchParams) {
  const newSearchParams = new URLSearchParams();
  searchParams.forEach((value, key) => {
    if (key.endsWith('[]')) {
      value.split(',').forEach((val) => newSearchParams.append(key, decodeURIComponent(val)));
    } else {
      newSearchParams.append(key, decodeURIComponent(value));
    }
  });
  return newSearchParams;
}

export function hydrateIsAvailableParam(searchParams: URLSearchParams) {
  if (searchParams.get(CatalogRequestParams.IS_AVAILABLE) !== 'true') {
    searchParams.delete(CatalogRequestParams.IS_AVAILABLE);
  }

  return searchParams;
}

export function encodeUrlParams(searchParams: Record<string, string | Array<string>>) {
  const encodedSearchParams = searchParams;
  Object.keys(searchParams).forEach((key) => {
    const value = searchParams[key];
    if (value instanceof Array) {
      encodedSearchParams[key] = value.map((value) => {
        return encodeURIComponent(value);
      });
    } else {
      encodedSearchParams[key] = encodeURIComponent(value);
    }
  });
  return encodedSearchParams;
}
